import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#6366F1',
        secondary: '#ffde59'
      }
    }
  }
}

export default new Vuetify(opts)
